/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Router configuration for Wizard Order template with mode "Edit"
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

 import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
 import { IAppRouterConfiguration } from '../appRouterTypes';
 import { RoutePath } from './routesConstants';

 export const WizardOrderTemplateEditConfiguration: IAppRouterConfiguration[] = [
     {
         path: RoutePath.wizardOrderTemplateEditFromDashbord,
         breadCrumbs: [EBreadCrumbType.reportsConstructor, EBreadCrumbType.wizardOrderTemplateEdit],
     },
     {
         path: RoutePath.wizardOrderTemplateEditFromAccount,
         breadCrumbs: [
             EBreadCrumbType.accounts,
             EBreadCrumbType.accountId,
             EBreadCrumbType.reportsConstructorFromAccount,
             EBreadCrumbType.wizardOrderTemplateEdit,
         ],
     },
     {
         path: RoutePath.wizardOrderTemplateEditFromAccountList,
         breadCrumbs: [
             EBreadCrumbType.accounts,
             EBreadCrumbType.reportsConstructorFromAccountList,
             EBreadCrumbType.wizardOrderTemplateEdit,
         ],
     },
     {
         path: RoutePath.wizardOrderTemplateEditFromMobileList,
         breadCrumbs: [
             EBreadCrumbType.subscriberMobile,
             EBreadCrumbType.reportsConstructorFromMobileList,
             EBreadCrumbType.wizardOrderTemplateEdit,
         ],
     },
     {
         path: RoutePath.wizardOrderTemplateEditFromAutoReports,
         breadCrumbs: [
             EBreadCrumbType.settingsAutoReports,
             EBreadCrumbType.reportsConstructorFromAutoReports,
             EBreadCrumbType.wizardOrderTemplateEdit,
         ],
     },
 ];
